<input autocomplete="off" type="text" #datepicker [(ngModel)]="date" class="form-control">